import React from "react";
import api from "../../api";
import {
  AccessKeyNormalRelation,
} from "../../api/models/access-key-model";
import dayjs from "dayjs";
import "./desktop-invitation-details.css";
import { AccessGroupsData } from "../../api/models/access-groups";
import AccessKeyDetails from "../AccessKeyDetails";
import { showError } from "../../utils/helpers";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { selectLabels } from "../../slices/language";

interface DesktopInvitationDetailsProps {
  invitationId: string | null;
}

const DesktopInvitationDetails = ({
  invitationId,
}: DesktopInvitationDetailsProps) => {
  const dispatch = useAppDispatch();
  const labels = useAppSelector(selectLabels);

  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [accessKey, setAccessKey] =
    React.useState<AccessKeyNormalRelation | null>(null);
  const [isSameDate, setIsSameDate] = React.useState<boolean>(false);
  const [accessGroups, setAccessGroups] = React.useState<AccessGroupsData[]>(
    []
  );
  const [visitorName, setVisitorName] = React.useState<string>("");
  const [verifiableId, setVerifiableId] = React.useState<string>("");

  React.useEffect(() => {
    if (invitationId) {
      getInvitationData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [invitationId]);

  const getInvitationData = async () => {
    if (invitationId) {
      try {
        setIsLoading(true);
        const response = await api.accessKeysByIdRequest(invitationId);
        if (response) {
          setVerifiableId(response?.data?.uuid);
          const currentAccessKey = response?.data?.access_key_qr;
          setAccessGroups(
            currentAccessKey?.access_groups ?? []
          );
          setAccessKey(currentAccessKey);
          const sameDate =
            dayjs(currentAccessKey?.valid_from).date() ===
              dayjs(currentAccessKey?.valid_until).date() &&
            dayjs(currentAccessKey?.valid_from).month() ===
              dayjs(currentAccessKey?.valid_until).month();
          setIsSameDate(sameDate);
          const isVerifiedVisitor =
            currentAccessKey?.verified_visitor === null
              ? null
              : currentAccessKey?.verified_visitor?.name || null;
          const isOtherProvider =
            currentAccessKey?.one_time_visitor?.provider_name || null;
          const isProvider =
            currentAccessKey?.one_time_visitor?.provider?.name || null;
          const isOneTimeVisitor =
            currentAccessKey?.one_time_visitor?.name || null;
          const InvName = isVerifiedVisitor
            ? isVerifiedVisitor
            : isOtherProvider
            ? isOtherProvider
            : isProvider
            ? isProvider
            : isOneTimeVisitor
            ? isOneTimeVisitor
            : "";
          setVisitorName(InvName);
        }
      } catch (error: any) {
        console.error(error);
        const errorMessage = error?.response?.data?.error?.message;
        showError(dispatch, errorMessage ? errorMessage : labels.generic_error);
      } finally {
        setIsLoading(false);
      }
    }
  };

  return (
    <AccessKeyDetails
      isLoading={isLoading}
      verifiableUUID={verifiableId}
      visitorName={visitorName}
      currentAccessKey={accessKey}
      accessGroups={accessGroups}
      isSameDate={isSameDate}
    />
  );
};

export default DesktopInvitationDetails;
